import { AnonymousRoute } from 'business/router/anonymous-route';
import { Routes } from 'business/router/constants';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { useTranslation } from 'translations/hooks';

const ErrorInfo = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <>
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </>
    );
  } else if (error instanceof Error) {
    return (
      <div>
        <h1>Error</h1>
        <p>{error.message}</p>
        <p>The stack trace is:</p>
        <pre>{error.stack}</pre>
      </div>
    );
  } else {
    return <h1>Unknown Error</h1>;
  }
};

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  return (
    <AnonymousRoute>
      <div className="flex h-full w-full flex-col items-center justify-center gap-4">
        <Link to={Routes.App}>{t('common.redirectHome')}</Link>
        <ErrorInfo />
      </div>
    </AnonymousRoute>
  );
};
